import { useQuery } from "react-query";

import { api } from "../util/api";

export function useCorporateUserRemainingInvitations() {
  return useQuery<number | undefined>(
    ["organisations", "corporate-user-remaining-invitations"],
    async () => {
      const response = await api.get<number | undefined>(
        "organisations/corporate-user-remaining-invitations"
      );
      if (response.status === 200) {
        return response.data;
      }

      return Promise.reject(response.status);
    },
    {
      keepPreviousData: true,
      retry: false,
      staleTime: 60000,
    }
  );
}
